import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import NextIconGray from '@/assets/icons/icon_next_gray.svg';
import NextIcon from '@/assets/icons/icon_next_white.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const BANNER_ASPECT_RATIO = 0.3125; // 400px / 1280px

export const Container = styled.div(
  (props: { count: number; isBgBlack: boolean }) =>
    mq({
      display: 'grid',
      width: '100%',
      backgroundColor: props.isBgBlack ? '#000' : '#F4F5F2',
      padding: [
        `${defaultTheme.spacing.l} 0`,
        `${defaultTheme.spacing.l} 0`,
        `${defaultTheme.spacing.l} 0`,
        `${defaultTheme.spacing.l} 0`,
      ],
      marginBottom: defaultTheme.spacing.xxl,
      '& > .swiper': {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        '& > .swiper-pagination-bullets': {
          display: 'grid',
          gridTemplateColumns: `repeat(${props.count}, minmax(10px, 48px))`,
          gridGap: [defaultTheme.spacing.xs, defaultTheme.spacing.s],
          justifyContent: 'center',
          position: 'initial',
          padding: `0 ${defaultTheme.spacing.l}`,
          marginTop: defaultTheme.spacing.l,
          '.swiper-pagination-bullet': {
            width: '100%',
            height: ['4px', '4px', '6px', '6px'],
            borderRadius: defaultTheme.border.radius.s,
            opacity: 0.5,
            margin: 0,
          },
          '.swiper-pagination-bullet-active': {
            opacity: 1,
          },
        },
        '.swiper-slide': {
          maxWidth: '600px',
        },
      },
      '& div': {
        '--swiper-theme-color': props.isBgBlack
          ? defaultTheme.color.white
          : defaultTheme.color.secondary,
        '--swiper-pagination-bullet-inactive-color': props.isBgBlack
          ? defaultTheme.color.white
          : defaultTheme.color.secondary,
      },
    }),
);

export const ListItem = styled.div((props: { isActive: boolean }) =>
  mq({
    width: '100%',
    maxWidth: '800px',
    height: '100%',
    opacity: props.isActive ? 1 : 0.5,
    transition: 'all .2s ease-out',
    '& > a': {
      width: '100%',
      height: '100%',
    },
  }),
);

export const DummyItem = styled.div(() =>
  mq({
    height: 0,
    paddingTop: `${BANNER_ASPECT_RATIO * 100}%`,
  }),
);

export const BannerLink = styled(Link)((props: { disabled?: boolean }) =>
  mq({
    pointerEvents: props.disabled ? 'none' : 'auto',
    ...hoverOpacity,
  }),
);

export const NavigationButton = styled.button(
  (props: {
    iconType: 'next' | 'prev';
    slideWidth: string;
    isBgBlack: boolean;
  }) =>
    mq({
      position: 'absolute',
      top: [
        `calc(50% - ${defaultTheme.spacing.l} - ${defaultTheme.spacing.s})`,
        `calc(50% - ${defaultTheme.spacing.l} - ${defaultTheme.spacing.s})`,
        `calc(50% - ${defaultTheme.spacing.l} - ${defaultTheme.spacing.l})`,
        `calc(50% - ${defaultTheme.spacing.l} - ${defaultTheme.spacing.l})`,
      ],
      right: props.iconType === 'next' && [
        `calc(50% - (calc(${props.slideWidth} / 2) + ${defaultTheme.spacing.xl}))`,
        `calc(50% - (calc(${props.slideWidth} / 2) + ${defaultTheme.spacing.xl}))`,
        `calc(50% - (calc(${props.slideWidth} / 2) + ${defaultTheme.spacing.xxl}))`,
        `calc(50% - (calc(${props.slideWidth} / 2) + 40px))`,
      ],
      left: props.iconType === 'prev' && [
        `calc(50% - (calc(${props.slideWidth} / 2) + ${defaultTheme.spacing.xl}))`,
        `calc(50% - (calc(${props.slideWidth} / 2) + ${defaultTheme.spacing.xl}))`,
        `calc(50% - (calc(${props.slideWidth} / 2) + ${defaultTheme.spacing.xxl}))`,
        `calc(50% - (calc(${props.slideWidth} / 2) + 40px))`,
      ],
      width: ['16px', '16px', '24px', '24px'],
      height: ['27.3px', '27.3px', '40.95px', '40.95px'],
      backgroundImage: props.isBgBlack
        ? `url(${NextIcon})`
        : `url(${NextIconGray})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      zIndex: '100',
      transform: `rotate(${props.iconType === 'prev' ? '180deg' : '0deg'})`,
      ...hoverOpacity,
    }),
);
